// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-sub-header {
  color: white;
  background: transparent;
  cursor: pointer;
  font-size: 20px;
}

.btn-sub-header:hover {
  color: red;
  font-weight: bold;
}

.header-search-container {
  flex: 1;
  max-width: 580px;
  margin: 0 24px;
}

.header-search-box {
  position: relative;
  width: 100%;
}
.header-search-box .search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.3rem;
  color: #9ca3af;
  pointer-events: none;
}
.header-search-box .header-search-input {
  height: 44px;
  padding-left: 44px;
  padding-right: 40px;
  border-radius: 22px;
  border: 1.5px solid #374151;
  background-color: #111827;
  color: #ffffff;
  font-size: 0.92rem;
  transition: all 0.25s ease;
}
.header-search-box .header-search-input::placeholder {
  color: #9ca3af;
  font-size: 0.88rem;
}
.header-search-box .header-search-input:focus {
  background-color: #1f2937;
  border-color: var(--color-principal, #dc2626);
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.25);
  color: #ffffff;
}
.header-search-box .btn-clear-search {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #9ca3af;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 2px 4px;
  display: flex;
  align-items: center;
}
.header-search-box .btn-clear-search:hover {
  color: #ffffff;
}

.search-bar {
  width: 700px;
  height: 50px;
  padding-left: 177px;
  display: flex;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
}

.open-menu {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.btn-check:checked + .btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check) + .btn:active {
  color: white;
  background-color: var(--color-principal);
  border-radius: 8px;
}

.btn-header-logout {
  border: 1px solid rgba(239, 68, 68, 0.5);
  color: #fca5a5;
  background-color: rgba(239, 68, 68, 0.1);
  font-size: 0.84rem;
  font-weight: 700;
  border-radius: 20px;
  padding: 6px 14px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-header-logout:hover {
  background-color: #dc2626;
  color: #ffffff;
  border-color: #dc2626;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss","webpack://./../../Universo%20Tunning/ecommerce/src/app/components/header/header.component.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;ACDJ;;ADGA;EACI,UAAA;EACA,iBAAA;ACAJ;;ADEA;EACE,OAAA;EACA,gBAAA;EACA,cAAA;ACCF;;ADEA;EACE,kBAAA;EACA,WAAA;ACCF;ADCE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;ACCJ;ADEE;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;ACAJ;ADEI;EACE,cAAA;EACA,kBAAA;ACAN;ADGI;EACE,yBAAA;EACA,6CAAA;EACA,6CAAA;EACA,cAAA;ACDN;ADKE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;ACHJ;ADKI;EACE,cAAA;ACHN;;ADQA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;ACLF;;ADOA;EACI,WAAA;EACA,aAAA;EACA,6BAAA;ACJJ;;ADMA;EACE,YAAA;EACA,wCAAA;EACA,kBAAA;ACHF;;ADMA;EACE,wCAAA;EACA,cAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,oBAAA;ACHF;ADKE;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,6CAAA;ACHJ","sourcesContent":["\n\n.btn-sub-header{\n    color: white;\n    background: transparent;\n    cursor: pointer;\n    font-size: 20px;\n}\n.btn-sub-header:hover{\n    color: red;\n    font-weight: bold;\n}\n.header-search-container {\n  flex: 1;\n  max-width: 580px;\n  margin: 0 24px;\n}\n\n.header-search-box {\n  position: relative;\n  width: 100%;\n\n  .search-icon {\n    position: absolute;\n    left: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 1.3rem;\n    color: #9ca3af;\n    pointer-events: none;\n  }\n\n  .header-search-input {\n    height: 44px;\n    padding-left: 44px;\n    padding-right: 40px;\n    border-radius: 22px;\n    border: 1.5px solid #374151;\n    background-color: #111827;\n    color: #ffffff;\n    font-size: 0.92rem;\n    transition: all 0.25s ease;\n\n    &::placeholder {\n      color: #9ca3af;\n      font-size: 0.88rem;\n    }\n\n    &:focus {\n      background-color: #1f2937;\n      border-color: var(--color-principal, #dc2626);\n      box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.25);\n      color: #ffffff;\n    }\n  }\n\n  .btn-clear-search {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: #9ca3af;\n    font-size: 1.25rem;\n    cursor: pointer;\n    padding: 2px 4px;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n      color: #ffffff;\n    }\n  }\n}\n\n.search-bar {\n  width: 700px;\n  height: 50px;\n  padding-left: 177px;\n  display: flex;\n  border-radius: 5px;\n  justify-content: center;\n  align-items: center;\n}\n.open-menu{\n    width: 100%;\n    display: flex;\n    justify-content: space-around;\n}\n.btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active {\n  color:white;\n  background-color: var(--color-principal);\n  border-radius: 8px;\n}\n\n.btn-header-logout {\n  border: 1px solid rgba(239, 68, 68, 0.5);\n  color: #fca5a5;\n  background-color: rgba(239, 68, 68, 0.1);\n  font-size: 0.84rem;\n  font-weight: 700;\n  border-radius: 20px;\n  padding: 6px 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    background-color: #dc2626;\n    color: #ffffff;\n    border-color: #dc2626;\n    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);\n  }\n}\n",".btn-sub-header {\n  color: white;\n  background: transparent;\n  cursor: pointer;\n  font-size: 20px;\n}\n\n.btn-sub-header:hover {\n  color: red;\n  font-weight: bold;\n}\n\n.header-search-container {\n  flex: 1;\n  max-width: 580px;\n  margin: 0 24px;\n}\n\n.header-search-box {\n  position: relative;\n  width: 100%;\n}\n.header-search-box .search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.3rem;\n  color: #9ca3af;\n  pointer-events: none;\n}\n.header-search-box .header-search-input {\n  height: 44px;\n  padding-left: 44px;\n  padding-right: 40px;\n  border-radius: 22px;\n  border: 1.5px solid #374151;\n  background-color: #111827;\n  color: #ffffff;\n  font-size: 0.92rem;\n  transition: all 0.25s ease;\n}\n.header-search-box .header-search-input::placeholder {\n  color: #9ca3af;\n  font-size: 0.88rem;\n}\n.header-search-box .header-search-input:focus {\n  background-color: #1f2937;\n  border-color: var(--color-principal, #dc2626);\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.25);\n  color: #ffffff;\n}\n.header-search-box .btn-clear-search {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #9ca3af;\n  font-size: 1.25rem;\n  cursor: pointer;\n  padding: 2px 4px;\n  display: flex;\n  align-items: center;\n}\n.header-search-box .btn-clear-search:hover {\n  color: #ffffff;\n}\n\n.search-bar {\n  width: 700px;\n  height: 50px;\n  padding-left: 177px;\n  display: flex;\n  border-radius: 5px;\n  justify-content: center;\n  align-items: center;\n}\n\n.open-menu {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n}\n\n.btn-check:checked + .btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check) + .btn:active {\n  color: white;\n  background-color: var(--color-principal);\n  border-radius: 8px;\n}\n\n.btn-header-logout {\n  border: 1px solid rgba(239, 68, 68, 0.5);\n  color: #fca5a5;\n  background-color: rgba(239, 68, 68, 0.1);\n  font-size: 0.84rem;\n  font-weight: 700;\n  border-radius: 20px;\n  padding: 6px 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.btn-header-logout:hover {\n  background-color: #dc2626;\n  color: #ffffff;\n  border-color: #dc2626;\n  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
